import { useChatContext } from "duck/ui/chat/contexts/useChatContext";

import { ViaductAction } from "./constants";
import { parseViaductLink } from "./utils";

interface Props {
  content: string;
}

const ViaductLink = ({ content }: Props) => {
  const { sendMessage, isStreaming } = useChatContext();

  const viaductLinkData = parseViaductLink(content);

  if (!viaductLinkData) {
    return null;
  }

  const { linkText, action, actionParameter } = viaductLinkData;

  const handleUserPromptActionClick = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();

    if (isStreaming) {
      return;
    }

    await sendMessage(actionParameter);
  };

  switch (action) {
    case ViaductAction.UserPrompt:
      return (
        <a
          href="#"
          className="text-gray-700 underline hover:text-gray-500 font-bold font-sans"
          onClick={handleUserPromptActionClick}
        >
          {linkText}
        </a>
      );
    default:
      return null;
  }
};

export default ViaductLink;
